import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Image = styled.img`
  height: ${props => props.isPdf ? '400px' : '100%'};
  ${props => props.isPdf ? 'min-width: 320px;' : 'width: 100%;'}
  ${props => props.limitImageSize ? 'max-height: 550px;' : ''}
  ${props => props.limitImageSize ? 'max-width: 500px;' : ''}
`;

const openFullView = ({ isPdf, ...img }) => {
  const html = `
    <${isPdf ? 'embed' : 'img'}
      ${isPdf ? 'title' : 'alt'}=${img.name}
      src='${img.src}'
      type='${img.type}'
      ${isPdf && `height='100%' width='100%'`}
    />
  `;

  window.open().document.write(html);
};

const setImageProps = image => {
  const { name, type } = image;

  const imgProps = {
    isPdf: /pdf$/i.test(type),
    className: 'document-image',
    name,
    src: image.srcUrl,
    type,
    limitImageSize: image?.limitImageSize
  };

  if (imgProps.isPdf) {
    imgProps.as = 'embed';
    imgProps.title = name;
  } else {
    imgProps.alt = name;
  }

  imgProps.openFullView = () => openFullView(imgProps);

  return imgProps;
};

const DocumentImage = ({ image }) => (
  <Image {...setImageProps(image)} />
);

DocumentImage.propTypes = {
  image: PropTypes.shape({
    name: PropTypes.string,
    srcUrl: PropTypes.string,
    type: PropTypes.string
  }).isRequired
};

export default DocumentImage;
